import { get, filter } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectSuites = state => searchEntities(state, 'suites', ['number', 'firstName', 'lastName', 'email']);

export const selectSuiteById = (state, id) => filter(selectSuites(state), suite => suite.id === id)[0];

export const selectSuiteAssets = (state, id) => get(selectSuiteById(state, id), ['assets'], []);

export const selectSuiteNotes = (state, id) => get(selectSuiteById(state, id), ['notes'], []);

export const selectSuiteDocuments = (state, id) => get(selectSuiteById(state, id), ['documents'], []);

export const selectSuiteServiceRequests = (state, id) => get(selectSuiteById(state, id), ['service_requests'], []);
